import { combineReducers } from '@reduxjs/toolkit';
import createDeviceReducer from './create-device';
import getDeviceReducer from './get-device';
import getDeviceListReducer from './get-device-list';
import updateDeviceReducer from './update-device';

const deviceReducer = combineReducers({
  createDevice: createDeviceReducer,
  getDevice: getDeviceReducer,
  getDeviceList: getDeviceListReducer,
  updateDevice: updateDeviceReducer
});

export default deviceReducer;